import { Outlet } from 'react-router-dom';

/**
 * ProtectedRoute component - Currently allows access without authentication
 * Authentication state is still tracked for conditional features (favorites, profile, etc.)
 */
export const ProtectedRoute = () => {
  // Allow access to all routes without requiring authentication
  // Individual components can check auth state for conditional features
  return <Outlet />;
};
